import { useBookContext } from "../../../context/book/book-context";
import CircularProgress from "../../circular-progress/circular-progress";
import { useAudio } from "../audio/context/audio-context";
import { calculateTotalProgress } from "../utils";
import * as S from "./header.style";
import React from "react";
// import { UserService } from "../../../../services/user";
import { UserService } from "../../../../../services/user";
import RDP_CONFIG from "../../../../../config";

export const AudioHeader = () => {
  const { book, currentChapter } = useBookContext();
  const { progressChaptersGroup } = useAudio();

  const total = calculateTotalProgress(progressChaptersGroup, book);

  const getFileUrl = (audio) => {
    var accessToken = UserService.getUser().access_token;
    const path = `https://${RDP_CONFIG.domain}/storage/${RDP_CONFIG.apiVersion}/content?uid=${audio}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}&access_token=${accessToken}`
    // audio += "&access_token=" + accessToken;
    return path;
  }

  const formatTime = (time) => {
    if (!time) return "00:00";
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    return `${hours > 0 ? `${hours}:` : ""}${
      hours > 0 && minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <S.Wrapper>
      <S.HeaderContent>
        <S.Thumb src={getFileUrl(book.thumb)} alt="Capa" />

        <S.Title>{book.title}</S.Title>

        <S.Title as="h4">{currentChapter.title}</S.Title>

        <S.Author>{book.author}</S.Author>
        
      </S.HeaderContent>
      <S.ProgressContent>
        <S.ProgressFlex>
          <CircularProgress progress={total} />
          {total.toFixed(0)}%
        </S.ProgressFlex>

        <span>{formatTime(book.duration)}</span>
      </S.ProgressContent>
    </S.Wrapper>
  );
};
